import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { SparklesIcon } from 'lucide-react';
export function ProofSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-80px'
  });
  return <section ref={ref} className="w-full bg-navy-900 py-16 md:py-24 relative overflow-hidden" data-id="element-240">
      <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-gold-500/40 to-transparent" data-id="element-241" />
      <div className="absolute bottom-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-gold-500/40 to-transparent" data-id="element-242" />
      <div className="absolute top-1/2 -translate-y-1/2 -left-32 w-64 h-64 bg-gold-500/5 rounded-full blur-3xl" data-id="element-243" />
      <div className="relative max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-244">
        <motion.div initial={{
        opacity: 0,
        y: 40
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.6,
        ease: 'easeOut'
      }} className="text-center" data-id="element-245">
          <SparklesIcon className="w-8 h-8 text-gold-500 mx-auto mb-6" aria-hidden="true" data-id="element-246" />
          <h2 className="font-heading text-3xl sm:text-4xl font-bold text-white mb-8" data-id="element-247">
            Imagina esto en <span className="text-gold-500" data-id="element-248">7 días</span>
          </h2>

          <p className="font-body text-lg sm:text-xl text-navy-100 leading-relaxed" data-id="element-249">
            Podrías estar sentado en tu nuevo hogar, con una{' '}
            <strong className="text-white" data-id="element-250">cuenta bancaria operativa</strong> y
            una <strong className="text-white" data-id="element-251">línea telefónica local</strong>,
            sabiendo exactamente cuánto dinero tienes y cuál es tu siguiente
            paso — en lugar de estar atrapado en un hotel gastando tus ahorros
            en comidas rápidas y transporte de emergencia.
          </p>
        </motion.div>
      </div>
    </section>;
}